import { createContext, useState } from "react";
import type { DialogTriggerProps } from "react-aria-components";
import { DialogTrigger as AriaDialogTrigger } from "react-aria-components";

export const DialogTriggerContext = createContext({ toggle: () => {} });

export function DialogTrigger(props: DialogTriggerProps) {
  const { ...dialogTriggerProps } = props;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <DialogTriggerContext.Provider
      value={{ toggle: () => setIsOpen((curr) => !curr) }}
    >
      <AriaDialogTrigger
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        {...dialogTriggerProps}
      />
    </DialogTriggerContext.Provider>
  );
}
